export default __webpack_public_path__ + "static/media/logo-pim.1f9e7742.png";